// Indicates if the client supports WebSockets.
module.exports = global.WebSocket !== undefined;
